<template>
  <div class="taglist-message" v-if="showRow">
    <div
      v-if="showMessageTypeBadge"
      class="tag-message-type"
      :class="messageTypeBadgeClass"
    >
      <md-icon v-if="messageTypeIcon" class="tag-message-type__icon">{{ messageTypeIcon }}</md-icon>
      <span v-if="messageTypeLabel">{{ messageTypeLabel }}</span>
    </div>
    <div class="taglist tag-list-date" v-if="mess.date">
      <span>{{ mess.date }}</span>
    </div>
    <div class="taglist tag-list-team" v-if="mess.team">
      <span>{{ mess.team }}</span>
    </div>
    <div class="taglist tag-list-place" v-if="mess.place">
      <span>{{ mess.place }}</span>
    </div>
    <div class="taglist" v-for="(other, index) in mess.others" :key="index">
      <span>{{ other }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "tag-chat-content",
    data() {
      return {
        categoryMessage: {
          'DEFAULT': 'KỶ LỤC MỚI',
          'REPORT': 'BÁO CÁO',
          'REWARD': 'KHEN THƯỞNG',
          'DISCIPLINE': 'KỶ LUẬT',
        }
      }
    },
    props: {
      mess: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    computed: {
      hasStructuredTags() {
        const m = this.mess;
        return !!(m.date || m.team || m.place || (m.others && m.others.length));
      },
      /** Chỉ badge loại tin khi có category (DEFAULT/REPORT/…). Tin nhắn thường không hiển thị icon trên bubble. */
      showMessageTypeBadge() {
        return !!this.mess.category;
      },
      showRow() {
        return this.showMessageTypeBadge || this.hasStructuredTags;
      },
      messageTypeIcon() {
        return this.categoryMaterialIcon(this.mess.category) || '';
      },
      messageTypeLabel() {
        if (!this.mess.category) return '';
        return this.categoryMessage[this.mess.category] || '';
      },
      messageTypeBadgeClass() {
        return {
          'active-normal': this.mess.category == 'DEFAULT',
          'active-report': this.mess.category == 'REPORT',
          'active-bonus': this.mess.category == 'REWARD',
          'active-discipline': this.mess.category == 'DISCIPLINE'
        };
      },
    },
    methods: {
      categoryMaterialIcon(category) {
        const map = {
          DEFAULT: 'emoji_events',
          REPORT: 'assignment',
          REWARD: 'card_giftcard',
          DISCIPLINE: 'gavel',
        };
        return map[category] || '';
      },
    }
  }
</script>
<style lang="scss">
.taglist-message {
  display: flex;
  align-items: center;
  grid-gap: 5px;
  font-size: 13px;
  margin-bottom: 6px;
    font-weight: 600;
  flex-wrap: wrap;
  .taglist {
    background: #a3eeff;
    border-radius: 5px;
    padding: 3px 6px;
    color: #343434;
  }
  .tag-message-type {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #fff;
    border-radius: 2px;

    .tag-message-type__icon {
      font-size: 16px !important;
      width: 16px;
      min-width: 16px;
      height: 16px;
      margin: 0 !important;
      color: inherit !important;
    }

  }
  .active-normal{
      color: #18a619;
    }
    .active-report{
      color: #376BFB;
    }
    .active-bonus{
      color: #FF7B00;
    }
    .active-discipline{
      color: #D14343;
    }
}
</style>
